module.exports = __webpack_public_path__ + "static/media/game_cover_flamingcore@768.2af0d0f3.png";